import { theme } from '@bottlebooks/gatsby-design-system';
export default Object.assign(Object.assign({}, theme.sizes), { menubar: 70 });
//# sourceMappingURL=sizes.js.map